import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Get auth token from localStorage
const getAuthHeader = () => {
  const token = localStorage.getItem('adminToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

class CategoryService {
  // Get all categories
  async getAll(params = {}) {
    try {
      const response = await axios.get(`${API_URL}/admin/categories`, {
        headers: getAuthHeader(),
        params
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Alias for getAll (for consistency)
  async getAllCategories(params = {}) {
    return this.getAll(params);
  }

  // Get single category
  async getById(id) {
    try {
      const response = await axios.get(`${API_URL}/admin/categories/${id}`, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Create category
  async create(categoryData) {
    try {
      const formData = new FormData();
      
      Object.keys(categoryData).forEach(key => {
        if (key === 'image' && categoryData[key]) {
          formData.append('image', categoryData[key]);
        } else if (categoryData[key] !== null && categoryData[key] !== undefined) {
          formData.append(key, categoryData[key]);
        }
      });

      const response = await axios.post(`${API_URL}/admin/categories`, formData, {
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Update category
  async update(id, categoryData) {
    try {
      const formData = new FormData();
      
      Object.keys(categoryData).forEach(key => {
        if (key === 'image' && categoryData[key]) {
          // Only append if it's a File object (new upload)
          if (categoryData[key] instanceof File) {
            formData.append('image', categoryData[key]);
          }
        } else if (categoryData[key] !== null && categoryData[key] !== undefined) {
          formData.append(key, categoryData[key]);
        }
      });

      const response = await axios.put(`${API_URL}/admin/categories/${id}`, formData, {
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Delete category
  async delete(id) {
    try {
      const response = await axios.delete(`${API_URL}/admin/categories/${id}`, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Handle errors
  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data.message || 'An error occurred',
        errors: error.response.data.errors || []
      };
    }
    return {
      message: 'Network error. Please check your connection.',
      errors: []
    };
  }
}

export default new CategoryService();
